var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SortOrder } from '@onereach/billing-shared';
import { BaseApi } from '../baseApi';
export default class ReportingDatabasesApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'reporting-databases';
    }
    getReportingDatabases() {
        return __awaiter(this, arguments, void 0, function* (params = {
            page: 1,
            limit: 10,
            sortBy: 'createdAt',
            sortOrder: SortOrder.ASC,
        }, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params }, options));
        });
    }
    getReportingDatabaseCredentials(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${id}/credentials`,
            });
        });
    }
    getEventSettings(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${id}/event-settings`,
            });
        });
    }
    updateEventSetting(id, eventType, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${id}/event-settings/${eventType}`,
                data,
            });
        });
    }
    getUsageCollectionSettings(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${id}/usage-collection-settings` }, options));
        });
    }
    updateUsageCollectionSettings(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${id}/usage-collection-settings`,
                data,
            });
        });
    }
    createReportingDatabase(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updateReportingDatabase(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: { id },
                data,
            });
        });
    }
    updateReportingDatabaseCredentials(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${id}/credentials`,
                data: credentials,
            });
        });
    }
    deleteReportingDatabase(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id,
                    softDelete,
                },
            });
        });
    }
}
//# sourceMappingURL=index.js.map